/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import User from "../models/userModel";
import {deleteFromLocal} from "./storageUtil";
import {SELECTED_ACCOUNT_KEY} from "./constants";

let isAdminLogin: boolean = false;

export const hasAdminLogin = (): boolean => isAdminLogin;

export function onAdminLogout(): Promise<User> {
    return new Promise<User>((resolve, reject) => {
        deleteFromLocal(SELECTED_ACCOUNT_KEY);
        User.get(null, (user: User | null) => {
            if (user) resolve(user);
            else reject();
        });
    });
}

export function setIsAdminLogin(value: boolean) {
    isAdminLogin = value;
}